import classNames from 'classnames';
import { Controller } from 'react-hook-form';
import {
  FormFeedback,
  Input,
  InputGroup,
  InputGroupText,
  Label
} from 'reactstrap';

const CustomInput = ({
  id,
  name,
  label,
  error,
  type,
  control,
  placeholder,
  group = false,
  rows,
  bottom
}) => {
  return (
    <div className={classNames('form-group', bottom ? 'mb-0' : 'mb-3')}>
      {label && <Label for={id}>{label}</Label>}
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <InputGroup
            className={classNames(group ? 'input-group-merge' : 'input-group', {
              'is-invalid': !!error
            })}
          >
            <Input
              {...field}
              type={type}
              id={id}
              style={{
                height: rows ? rows : undefined
              }}
              placeholder={placeholder}
              invalid={!!error}
            />
            {group && <InputGroupText>{group}</InputGroupText>}
            {error && <FormFeedback> {error.message}</FormFeedback>}
          </InputGroup>
        )}
      />
    </div>
  );
};

export default CustomInput;
